module.exports = __webpack_public_path__ + "static/img/video-frame.eed48e3.png";